<template>
    <div>
        <v-container class="white ma-0 pa-0" v-if="exibirLinhaDoTempo">
            <div class="pt-5 pl-5" style="max-width: 200px">
                <v-tooltip
                    top
                    max-width="200">
                    <template v-slot:activator="{ on }">
                        <div v-on="on">
                            <v-btn
                                @click="abrirModalNovaReavaliacao"
                                color="primary"
                                class="call-to-action text-body-2"
                                :disabled="!verificaPermissaoEdicao">
                                Nova Reavaliação
                                <v-icon right dark>
                                    add
                                </v-icon>
                            </v-btn>
                        </div>
                    </template>
                    <span>Não é possível realizar Reavaliação de patrimônios que atingiram o fim da vida útil.</span>
                </v-tooltip>
            </div>
        </v-container>
        <v-container class="white d-flex justify-center align-center" style="min-height:66vh;" v-else>
            <div class="text-center mb-12">
                <p class="az-title__subtitle">
                    Nenhuma
                    <span class="session-title">reavaliação</span>
                    realizada, clique para adicionar
                </p>

                <v-tooltip
                    top
                    max-width="290">
                    <template v-slot:activator="{ on }">
                        <div v-on="on" :class="{'btn-disabled': !patrimonio.tipo}">
                            <v-btn
                                @click="abrirModalNovaReavaliacao"
                                color="primary"
                                class="call-to-action text-body-2"
                                :disabled="!verificaPermissaoEdicao">
                                Nova Reavaliação
                                <v-icon right dark>
                                    add
                                </v-icon>
                            </v-btn>
                        </div>
                    </template>
                    Não é possível realizar Reavaliação de patrimônios que atingiram o fim da vida útil.
                </v-tooltip>
            </div>
        </v-container>
    </div>
</template>

<script>
    import {createNamespacedHelpers, mapState} from 'vuex'
    import AzHasPermissions from '@azinformatica/loki/src/utils/AzHasPermissions'
    import moment from 'moment'

    const {mapGetters} = createNamespacedHelpers('CamposPersonalizados')

    export default {
        name: 'BotaoNovaReavaliacao',
        props: ['exibirLinhaDoTempo', 'exibirTooltipReavaliacao'],
        data() {
            return {
                tipo: ''
            }
        },
        computed: {
            ...mapState({patrimonio: state => state.patrimonio.patrimonio}),
            ...mapGetters(['getTooltipCamposPersonalizados']),
            verificaPermissaoEdicao() {
                const temPermissao = AzHasPermissions(this.$store.state.loki.user.authorities, ['Patrimonio.Normal'])
                const naoBaixado = this.patrimonio.situacao !== 'BAIXADO'
                const vidaUtilIndefinida = this.patrimonio.vidaIndefinida
                const vencimentoValido = vidaUtilIndefinida === true
                    || moment(this.patrimonio.fimVidaUtil).isAfter(moment(new Date()))

                return temPermissao && naoBaixado && vencimentoValido
            }
        },
        methods: {
            async abrirModalNovaReavaliacao() {
                this.$emit('abrirModalNovaReavaliacao')
            },
            cadastrarReavaliacao() {
                this.$emit('cadastrarReavaliacao', this.tipo)
                this.tipo = ''
            }
        }
    }
</script>
